/* eslint-disable max-len */
import {
  Box,
  Checkbox,
  FormControl,
  FormHelperText,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ContainerPainel from 'components/container_painel';
import { PacoteStatusEnum } from 'enum/pacoteStatus.enum';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { IQuestoesAmbientais, useQuestoesAmbientaisStore } from 'stores/forms/questoes_ambientais.store';
import ButtonForm from 'components/buttons/button-form';

const FormQuestoesAmbientaisEditar: React.FC = () => {
  const { uuid } = useParams();
  const {
    questoes,
    getQuestoes,
    setPartialForm,
    salvarRascunho,
    enviarAprovacao
  } = useQuestoesAmbientaisStore();
  const navigate = useNavigate();
  // Estado para controlar quais itens estão selecionados (checkbox)
  const [selectedIssues, setSelectedIssues] = useState<string[]>([]);

  const formik = useFormik({
    initialValues: {
      prioridadePoucosImoveisRegularizados: null,
      prioridadeSemTratamentoResiduos: null,
      prioridadeDegradacaoApp: null,
      prioridadeDegradacaoSolo: null,
      prioridadeDesmatamentoIlegal: null,
      prioridadePerdaBiodiversidade: null,
      prioridadeCriseHidrica: null,
      prioridadePoluicaoAgua: null,
      prioridadePoluicaoSolo: null,
      prioridadeQueimadas: null,
      prioridadeUsoAgrotoxicos: null,
      prioridadeMudancasClimaticas: null,
    },
    validate: (values) => {
      const errors: any = {};
      if (selectedIssues.length === 0) {
        errors.selectedIssues = 'Selecione pelo menos um problema ambiental';
      }
      for (const item of selectedIssues) {
        if (values[item as keyof typeof values] === null) {
          errors[item as keyof typeof values] = 'Selecione uma prioridade para o problema';
        }
      }

      return errors;
    },
    onSubmit: () => {
      handleSend();
    },
  })

  const makerIssues: { key: keyof IQuestoesAmbientais; label: string }[] = [
    { key: 'prioridadePoucosImoveisRegularizados', label: 'Poucos imóveis rurais regularizados ambientalmente' },
    { key: 'prioridadeSemTratamentoResiduos', label: 'Ausência de tratamento de resíduos sólidos (lixo)' },
    { key: 'prioridadeDegradacaoApp', label: 'Degradação das Áreas de Preservação Permanente (APP)' },
    { key: 'prioridadeDegradacaoSolo', label: 'Degradação do solo (processos erosivos, compactação, aventização, perda de fertilidade etc.)' },
    { key: 'prioridadeDesmatamentoIlegal', label: 'Desmatamento ilegal e degradação florestal' },
    { key: 'prioridadePerdaBiodiversidade', label: 'Perda da biodiversidade' },
    { key: 'prioridadeCriseHidrica', label: 'Crise Hídrica e perca de água' },
    { key: 'prioridadePoluicaoAgua', label: 'Poluição e contaminação da água' },
    { key: 'prioridadePoluicaoSolo', label: 'Poluição e contaminação do solo' },
    { key: 'prioridadeQueimadas', label: 'Queimadas e incêndios florestais' },
    { key: 'prioridadeUsoAgrotoxicos', label: 'Uso indiscriminado de agrotóxicos' },
    { key: 'prioridadeMudancasClimaticas', label: 'Mudanças climáticas / Eventos extremos de seca e cheias' }
  ];

  const handleSalvarComoRascunho = () => {
    const values = formik.values;
    (Object.keys(values) as (keyof typeof values)[]).forEach((k) => setPartialForm(k, values[k]));
    setPartialForm('pacote_status', PacoteStatusEnum.RASCUNHO);
    setTimeout(() => {
      salvarRascunho();
      alert('Rascunho salvo com sucesso');
      navigate('/pacote-de-formularios');
    }, 100);
  };

  const handleSend = async () => {
    (Object.keys(formik.values) as (keyof typeof formik.values)[]).forEach((k) => setPartialForm(k, formik.values[k]));
    setTimeout(async () => {
      const ok = await enviarAprovacao();
      if (ok) navigate('/pacote-de-formularios');
    }, 100);
  };


  const handleChangePriority = (key: keyof typeof formik.values, value: number | null) => {
    if (value === null) {
      formik.setFieldValue(key, null);
      return;
    }
    const newValues: any = { ...formik.values };
    const antigo = newValues[key];
    const mesmo = Object.keys(newValues).find(k => newValues[k] === value);
    if (mesmo) newValues[mesmo] = antigo;
    newValues[key] = value;
    formik.setValues(newValues);
  };


  const handleGetQuestoes = async () => {
    const response = await getQuestoes(uuid as string);
    const values: any = {
      prioridadePoucosImoveisRegularizados: response.prioridadePoucosImoveisRegularizados,
      prioridadeSemTratamentoResiduos: response.prioridadeSemTratamentoResiduos,
      prioridadeDegradacaoApp: response.prioridadeDegradacaoApp,
      prioridadeDegradacaoSolo: response.prioridadeDegradacaoSolo,
      prioridadeDesmatamentoIlegal: response.prioridadeDesmatamentoIlegal,
      prioridadePerdaBiodiversidade: response.prioridadePerdaBiodiversidade,
      prioridadeCriseHidrica: response.prioridadeCriseHidrica,
      prioridadePoluicaoAgua: response.prioridadePoluicaoAgua,
      prioridadePoluicaoSolo: response.prioridadePoluicaoSolo,
      prioridadeQueimadas: response.prioridadeQueimadas,
      prioridadeUsoAgrotoxicos: response.prioridadeUsoAgrotoxicos,
      prioridadeMudancasClimaticas: response.prioridadeMudancasClimaticas,
    };
    const issuesList: string[] = [];
    Object.keys(values).forEach((k) => { if (values[k] !== null) issuesList.push(k); });
    setSelectedIssues(issuesList);
    formik.setValues(values);
  };

  useEffect(() => { handleGetQuestoes(); }, []);
  useEffect(() => { formik.validateForm(); }, [selectedIssues]);

  return (
    <ContainerPainel
      pagina='Formulário de Questões Ambientais'
      showBackButton={true}
    >
      <Stack px="4rem" pt="2rem" alignItems="center" textAlign="center">
        <Typography sx={{ mt: 2, mb: 1, fontSize: 24, fontWeight: 400 }}>
          Cadastro de Questões Ambientais
        </Typography>
      </Stack>

      <Box display="flex" justifyContent="center" mt={3} mb={6}>
        <Box
          px="2rem"
          pb={4}
          sx={{
            bgcolor: '#fff',
            borderRadius: 2,
            boxShadow: 1,
            width: '100%',
            maxWidth: '1200px',
          }}
        >
          <Box mt={3}>
            <Typography
              sx={{
                fontFamily: 'Roboto',
                fontWeight: 500,
                fontStyle: 'normal',
                fontSize: '20px',
                lineHeight: '160%',
                letterSpacing: '0.15px',
                verticalAlign: 'middle',
              }}
            >
              Selecione os problemas existentes e defina suas prioridades
            </Typography>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '143%',
                letterSpacing: '0.17px',
                color: '#00000099'
              }}
            >
              Assinale quais os problemas ambientais mais significativos no meio rural do município e defina a ordem de prioridade
              (1 para o mais significativo, 2 para o segundo mais significativo, e assim por diante).
            </Typography>
            <Box mt={2} display="flex" alignItems="center" gap={2}>
              <Typography>Ano referência do Questionário: <b>{new Date().getFullYear() - 1}</b></Typography>
            </Box>
          </Box>

          <Box
            mt={2}
            p={2}
            borderRadius={1}
            sx={{
              backgroundColor: '#E8F1FD',
              border: '1px solid #D3E3FD'
            }}
          >
            <List dense disablePadding>
              <ListItem disableGutters>
                <ListItemIcon sx={{ minWidth: 28, color: '#1976d2' }}>
                  <InfoOutlinedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  sx={{
                    fontWeight: 400,
                    fontSize: '14px',
                    lineHeight: '150%',
                    letterSpacing: '0.15px',
                    color: '#11254F'
                  }}
                  primary="As prioridades são automáticas: se você selecionar uma prioridade já usada, ela será trocada automaticamente."
                />
              </ListItem>
            </List>
          </Box>

          <form onSubmit={formik.handleSubmit}>
            <Grid container mt={3} columnSpacing={4}>
              <Grid item xs={12} md={8}>
                <Typography fontWeight={700} mb={1}>Problemas</Typography>
              </Grid>
              <Grid item xs={12} md={4} display="flex" justifyContent="flex-end">
                <Typography
                  fontWeight={700}
                  mb={1}
                  sx={{
                    textAlign: "right",
                    width: "100%"
                  }}
                >
                  Prioridades
                </Typography>
              </Grid>

              {Object.keys(formik.values).map((key, idx) => (
                <React.Fragment key={idx /* NOSONAR */}>
                  <Grid item xs={12} md={8} display="flex" alignItems="center" gap={1.5}>
                    <Checkbox
                      checked={selectedIssues.includes(key)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          handleChangePriority(key as keyof typeof formik.values, selectedIssues.length + 1);
                          setSelectedIssues([...selectedIssues, key]);
                        } else {
                          const removed = formik.values[key as keyof typeof formik.values] as number | null;
                          handleChangePriority(key as keyof typeof formik.values, null);
                          const novos = selectedIssues.filter(i => i !== key);
                          setSelectedIssues(novos);
                          if (removed !== null) {
                            const newValues: any = { ...formik.values, [key]: null };
                            Object.keys(newValues).forEach(k => {
                              const cur = newValues[k];
                              if (cur !== null && cur > removed) newValues[k] = cur - 1;
                            });
                            formik.setValues(newValues);
                          }
                        }
                      }}
                    />
                    <Typography>{makerIssues.find(i => i.key === key as any)?.label}</Typography>
                  </Grid>

                  <Grid item xs={12} md={4} display="flex" justifyContent="flex-end">
                    <FormControl sx={{ minWidth: 56, maxWidth: 80 }}>
                      <Select
                        value={formik.values[key as keyof typeof formik.values] ?? ''}
                        onChange={(e) => handleChangePriority(key as keyof typeof formik.values, Number(e.target.value))}
                        disabled={!selectedIssues.includes(key)}
                        displayEmpty
                      >
                        <MenuItem value="">
                          <em>—</em>
                        </MenuItem>
                        {Array.from({ length: selectedIssues.length }, (_, i) => (
                          <MenuItem key={i} value={i + 1}>{i + 1}</MenuItem>
                        ))}
                      </Select>
                      <FormHelperText error={Boolean(formik.errors[key as keyof typeof formik.values])}>
                        {formik.errors[key as keyof typeof formik.values] as any}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                </React.Fragment>
              ))}

              {/* Outro problema ambiental */}
            </Grid>

            {/* Rodapé: contador + botões */}
            {/* <Box mt={4} display="flex" justifyContent="space-between" alignItems="center">
              <Typography>{selectedIssues.length} problema(s) selecionado(s)</Typography>
              <BottomActionButtons
                handleSalvarRascunho={handleSalvarComoRascunho}
                handleEnviarAprovacao={handleSend}
                isFormValid={formik.isValid}
                handleCancelar={() => navigate(-1)}
              />
            </Box> */}
          </form>
        </Box>
      </Box>

      <ButtonForm
        disabled={!formik.isValid}
        onBack={() => navigate(-1)}
        onConfirmSave={handleSend}
        onSaveDraft={handleSalvarComoRascunho}
      />
    </ContainerPainel>
  );
};

export default FormQuestoesAmbientaisEditar;
